const Onlytesting = () => {
  return <div className="my-10 mx-10"></div>;
};

export default Onlytesting;
